var map = {
	"./18PW.png": 27630,
	"./19PW.png": 48304,
	"components/Catalog/PW/img/inserDoor/ks/ksPlusBlack/18PW.png": 27630,
	"components/Catalog/PW/img/inserDoor/ks/ksPlusBlack/19PW.png": 48304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32335;